import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { formatPhone } from 'src/utils/format-phone';
import { MarketingConsentRecord } from 'src/trpc';

export const MarketingColumns: ColumnDef<MarketingConsentRecord>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Customer name
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ row }) => (
      <span className="font-medium text-gray-900">{row.original.name || 'Unknown'}</span>
    ),
  },
  {
    accessorKey: 'phone',
    header: () => <span className="text-xs font-semibold uppercase tracking-wide">Phone number</span>,
    cell: ({ row }) => (
      <span className="tabular-nums text-gray-700">{formatPhone(row.original.phone || '')}</span>
    ),
  },
  {
    accessorKey: 'optInTimestamp',
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        >
          Opt-in date
          {!column.getIsSorted() && <ArrowUpDown className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'asc' && <ArrowUp className="ml-2 h-4 w-4" />}
          {column.getIsSorted() === 'desc' && <ArrowDown className="ml-2 h-4 w-4" />}
        </Button>
      );
    },
    cell: ({ row }) => {
      const ts = row.original.optInTimestamp;
      if (!ts) return <span className="text-gray-400">-</span>;
      return (
        <span className="tabular-nums text-gray-700">
          {new Date(ts).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </span>
      );
    },
  },
  {
    accessorKey: 'status',
    header: () => <span className="text-xs font-semibold uppercase tracking-wide">Status</span>,
    cell: ({ row }) => {
      const status = row.original.status;
      return (
        <span
          className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${
            status === 'opted_in'
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-600'
          }`}
        >
          {status === 'opted_in' ? 'Opted in' : 'Opted out'}
        </span>
      );
    },
  },
];
